import { Link } from "react-router-dom";
import { SEASON_CONFIG, seasonPhase, type SeasonPhase } from "@/lib/season";
import { cn } from "@shared/lib/utils";
import { Countdown } from "./Countdown";

const PHASE_COPY: Record<SeasonPhase, { label: string; tone: string; note: string }> = {
  prep: { label: "Season Prep", tone: "text-ink-dim", note: "Season 1 starts soon" },
  live: { label: "Season Live", tone: "text-accent", note: "IP race in progress" },
  snapshot: {
    label: "Snapshot Soon",
    tone: "text-yellow",
    note: "Final IP snapshot — card actions close",
  },
  settlement: { label: "Settlement", tone: "text-ink-dim", note: "Airdrop settlement in progress" },
};

/**
 * R-17 전역 시즌 상태 배너 — 준비/진행/스냅샷/정산 4상태를 모든 셸 화면 상단에
 * 표시하고 /season으로 연결한다. 스냅샷 상태에서는 마감 카운트다운을 병기한다.
 */
export function SeasonPhaseBanner() {
  const phase = seasonPhase();
  const copy = PHASE_COPY[phase];
  const showCountdown = (phase === "live" || phase === "snapshot") && SEASON_CONFIG.endsAt;

  return (
    <Link
      to="/season"
      className="flex h-8 items-center justify-center gap-2.5 border-b border-line bg-(--ty-bg-2) px-4 transition-colors duration-200 hover:bg-(--ty-bg-3)"
      aria-label={`${SEASON_CONFIG.label}: ${copy.label}`}
    >
      <span className={cn("font-mono text-[10px] font-semibold uppercase tracking-[0.16em]", copy.tone)}>
        {SEASON_CONFIG.label} · {copy.label}
      </span>
      <span className="hidden text-[11px] text-ink-mute sm:inline">{copy.note}</span>
      {showCountdown && (
        <Countdown
          to={SEASON_CONFIG.endsAt!}
          className="font-mono text-[10px] tabular-nums text-ink-dim"
        />
      )}
    </Link>
  );
}
